import type {DefaultOptions} from '../../../types';
import type {CurrentValueComponentProps, RangeValueEditorOptions} from './types';
import DirectInputTemplate from './DirectInputTemplate.svelte';
import type {RangeValueEditorLocalizations} from './types';
import type {SvelteComponentConstructor} from 'core/types';
import type {RangeValueEditorModel} from './types';
import {isEqual} from 'lodash-es';
import {isNullOrUndefined} from '../../../../utils/custom-utils';

/**
 * @ngdoc constant
 * @name RANGE_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.range
 *
 * @description
 * For description see {@link RangeValueEditorOptions}
 *
 * ```javascript
 * {
 *     extremesAsNull: true,
 *     min: 0,
 *     max: 100,
 *     step: 1,
 *     pitPoints: undefined,
 *     currentValueTemplate: DirectInputTemplate,
 *     customEmptyAsNullCheck: ({value}: {value: RangeValueEditorModel}) => isNullOrUndefined(value) || isEqual(value, {})
 * }
 * ```
 */
export const RANGE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<RangeValueEditorOptions> = {
    extremesAsNull: true,
    min: 0,
    max: 100,
    step: 1,
    pitPoints: undefined,
    currentValueComponent: DirectInputTemplate as SvelteComponentConstructor<CurrentValueComponentProps>,
    customEmptyAsNullCheck: ({value}: {value: RangeValueEditorModel}) => isNullOrUndefined(value) || isEqual(value, {})  || isEqual(value, EMPTY_MODEL)
};

export const EMPTY_MODEL: RangeValueEditorModel = {
    from: null,
    to: null
};

/**
 * @ngdoc constant
 * @name RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.range
 *
 * @description
 * ```
 * {
 *     description: '',
 *     to: 'To',
 *     from: 'From'
 * }
 * ```
 */
export const RANGE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<RangeValueEditorLocalizations>({
    description: '',
    to: 'To',
    from: 'From'
});